module.exports = __webpack_public_path__ + "assets/images/announcement-temperature-3rd-gen.png";